import Vue from 'vue'
import VueRouter from 'vue-router'
import {authGuard, checkPolicy} from "./guards/authGuard"

Vue.use(VueRouter)

// Add a function to redirect : dashboard-audits or dashboard-installs

const routes = [
  { path: '/', redirect: '/dashboard-audits' },

  {
    path: '/test',
    name: 'test',
    component: () => import('../views/Test.vue'),
    beforeEnter: authGuard,
    hash: '',
    meta: {
      roles: ["admin"],
      label: "Test"
    }
  },

  {
    path: '/dashboard-audits',
    name: 'dashboard-audits',
    component: () => import('../views/Dashboard/Dashboard.vue'),
    beforeEnter: authGuard,
    hash: '',
    meta: {
      roles: ["admin", "data-analyst", "user-manager"],
      label: "Mes audits"
    }
  },

  // { path: '/', redirect: '/dashboard-audits' },
  //
  // {
  //   path: '/dashboard-audits',
  //   name: 'dashboard-audits',
  //   component: () => import('../views/Dashboard/Dashboard.vue'),
  //   beforeEnter: authGuard,
  //   hash: '',
  //   meta: {
  //     roles: ["admin", "data-analyst", "user-manager", "user"],
  //     label: "Mes audits"
  //   }
  // },
  {
    path: '/dashboard-parc',
    name: 'dashboard-parc',
    component: () => import('../views/Dashboard/Parc.vue'),
    beforeEnter: authGuard,
    hash: '',
    meta: {
      roles: ["admin", "data-analyst", "user-manager"],
      //label: "parc"
    }
  },
  
  {
    path: '/dashboard-fleet',
    name: 'dashboard-fleet',
    component: () => import('../views/Dashboard/fleet/fleet.vue'),
    beforeEnter: authGuard,
    hash: '',
    meta: {
      roles: ["admin", "data-analyst", "user-manager", "user"],
      //label: "fleet"
    }
  },

  {
    path: '/dashboard-manager',
    name: 'dashboard-manager',
    component: () => import('../views/Dashboard/operation/management.vue'),
    beforeEnter: authGuard,
    hash: '',
    meta: {
      roles: ["admin", "data-analyst", "user-manager", "user"],
      //label: "fleet"
    }
  },
  {
    path: '/dashboard-clean',
    name: 'dashboard-clean',
    component: () => import('../views/Dashboard/fleetClean/fleetClean.vue'),
    beforeEnter: authGuard,
    hash: '',
    meta: {
      roles: ["admin", "data-analyst", "user-manager", "user"],
      //label: "fleet"
    }
  },

  {
    path: '/dashboard-installs',
    name: 'dashboard-installations',
    component: () => import('../views/Dashboard/Dashboard.vue'),
    beforeEnter: authGuard,
    meta: {
      roles: ["admin", "data-analyst", "user-manager", "user"],
      label: "Mes installations"
    }
  },

  {
    name: 'installation-show',
    path: '/installations/show/:id',
    component: () => import('../views/Installations/Show.vue'),
    beforeEnter: checkPolicy,
    meta: {
      roles: ["admin", "data-analyst", "user-manager", "user"],
      label: 'Diagnostic installation'
    }
  },
  {
    name: 'dashboard-under-perf',
    // path: '/installations/:id/under-perf/:target_menu',
    path: '/installations/:id/under-perf',
    component: () => import('../views/Installations/UnderPerf.vue'),
    beforeEnter: checkPolicy,
    meta: {
      roles: ["admin", "data-analyst", "user-manager", "user"],
      label: 'Historique de sous-performance'
    },
  },

  {
    name: 'dashboard-losses-waterfall',
    // path: '/installations/:id/losses-waterfall/:target_menu',
    path: '/installations/:id/losses-waterfall',
    beforeEnter: checkPolicy,
    component: () => import('../views/Installations/LossesWaterfall.vue'),
    meta: {
      roles: ["admin", "data-analyst", "user-manager", "user"],
      label: 'Cascade des pertes'
    },
  },

  {
    name: 'expert-module',
    path: '/expert-mod/:id/:expert/:sel_pdm',
    beforeEnter: checkPolicy,
    component: () => import('../views/Experts/MainExpert.vue'),
    meta: {
      roles: ["admin", "data-analyst", "user-manager", "user"],
      label: 'Module Expert : '
    }
  },

  {
    name: 'smart-guard',
    path: '/smart-guard/:id',
    beforeEnter: checkPolicy,
    component: () => import('../views/Dashboard/SmartGuard.vue'),
    meta: {
      roles: ["admin", "data-analyst", "user-manager", "user"],
      label: 'Smart Guard'
    }
  },
  {
    name: 'helio-clean',
    path: '/helio-clean/:id',
    beforeEnter: checkPolicy,
    component: () => import('../views/Dashboard/helio-clean/helioClean.vue'),
    meta: {
      roles: ["admin", "data-analyst", "user-manager", "user"],
      label: 'Helio Clean'
    }
  },

  {
    name: 'expert-layout',
    path: '/expert-layout/:id/layout',
    beforeEnter: checkPolicy,
    component: () => import('../views/Experts/ExpertLayout.vue'),
    meta: {
      roles: ["admin", "data-analyst", "user-manager", "user"],
      label: '_module_calepinage_ : '
    }
  },

  {
    name: 'expert-pvsyst',
    path: '/expert-pvsyst/:id/pvsyst',
    beforeEnter: checkPolicy,
    component: () => import('../views/Experts/ExpertPvsyst.vue'),
    meta: {
      roles: ["admin", "data-analyst", "user-manager", "user"],
      label: '_module_pvsyst_ : '
    }
  },

 {
   name: 'expert-kpi',
   path: '/expert-kpi/:id/kpi_filter',
   beforeEnter: checkPolicy,
   component: () => import('../views/Experts/ExpertKPI.vue'),
   meta: {
     roles: ["admin", "data-analyst", "user-manager", "user"],
     label: '_module_kpi_ : '
   }
 },

  {
    name: 'expert-incident',
    path: '/expert-incident/:id/incident',
    beforeEnter: checkPolicy,
    component: () => import('../views/Experts/ExpertIncident.vue'),
    meta: {
      roles: ["admin", "data-analyst", "user-manager", "user"],
      label: '_module_incident_ : '
    }
  },

  {
    name: 'expert-img',
    path: '/expert-img/:id/:expert/',
    beforeEnter: checkPolicy,
    component: () => import('../views/Installations/ExpertImgModule.vue'),
    meta: {
      roles: ["admin", "data-analyst", "user-manager", "user"]
    }
  },

  {
    name: 'create-audit',
    path: '/audit/create',
    beforeEnter: checkPolicy,
    component: () => import('../views/Audits/Create.vue'),
    meta: {
      roles: ["admin", "data-analyst"]
    }
  },

  {
    name: 'plotly-creator',
    path: '/plotly',
    beforeEnter: checkPolicy,
    component: () => import('../views/PlotlyCreator.vue'),
    meta: {
      roles: ["admin"],
      label: 'Plotly Creator'
    },
  },

  {
    name: 'virtual-sensor',
    path: '/virtual-sensor',
    beforeEnter: checkPolicy,
    component: () => import('../views/NanoGUNE/NanoGUNE.vue'),
    meta: {
      roles: ["admin", "data-analyst"]
    }
  },

  {
    name: 'pdf-report',
    path: '/pdf-report/:id',
    beforeEnter: checkPolicy,
    component: () => import('../views/Installations/PdfReport.vue'),
    meta: {
      roles: ["admin", "data-analyst", "user-manager", "user"]
    }
  },

  {
    name: 'analyst-mod',
    path: '/analyst-mod/:id',
    beforeEnter: checkPolicy,
    component: () => import('../views/Installations/AnalystPicModule.vue'),
    meta: {
      roles: ["admin", "data-analyst"]
    }
  },

  // Authentification
  {
    path: '/login',
    name: 'login',
    meta: {
      layout: 'empty',
      roles: ["admin", "data-analyst", "user-manager", "user"]
    },
    component: () => import('../views/Auth/Login.vue'),

  },

  {
    path: '/logout',
    name: 'logout',
    meta: {
      layout: 'empty',
      roles: ["admin", "data-analyst", "user-manager", "user"]
    },
    component: () => import('../views/Auth/Logout.vue'),
  },

  {
    path: '/set-account/:token',
    name: 'set-account',
    meta: {
      layout: 'empty',
    },
    component: () => import('../views/Auth/SetAccount.vue'),
  },

  {
    path: '*',
    name: 'error',
    meta: {
      layout: 'empty',
    },
    component: () => import('../views/Error.vue'),
  }
]

const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      const position = {}
      if (to.hash) {
        position.selector = to.hash
        return false
      }
    }
  },
})

export default router
